<template>
  <div>
    <div
      class="lead-update--tab"
      :class="{'is-hidden': activeTab != tab.name }"
      :key="tab.name"
      v-if="tab.children"
      v-for="tab in elements"
    >
      <div class="row gutter-lg">
        <div class="col-md-5 col-lg-5 offset-md-1">
          <lead-update-monitor
            @openBusinessCard="triggerPopup"
            :structure="structure"
            :progress="progress"
            :errors="errors"
            :users="users"
            class="inside-content"
            @input="nestedUpdate"
            :item="item"
            :leadReviewEnabled="leadReviewEnabled"
            :class="{'hide': !showUpdateMonitor, 'show': showUpdateMonitor}"
          >
            <p>{{savedAt}}</p>
          </lead-update-monitor>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-ls-5 lead-mask">
          <lead-mask
            :language="language"
            :elements="tab.children"
            :item="item"
            :errors="errors"
            v-on:change="change"
            @populate-fields="populateFields"
          />
        </div>
      </div>
    </div>
    <div
      class="lead-update--tab lead-update--tab-kits"
      :class="{'is-hidden': activeTab != 'kits_tab' }"
    >
      <div class="row gutter-lg">
        <!-- KITS -->
        <div class="col-md-5 col-lg-5 offset-md-1">
          <lead-update-monitor
            @openBusinessCard="triggerPopup"
            :structure="structure"
            :progress="progress"
            :errors="errors"
            :users="users"
            class="inside-content"
            @input="nestedUpdate"
            :item="item"
            :leadReviewEnabled="leadReviewEnabled"
            :class="{'hide': !showUpdateMonitor, 'show': showUpdateMonitor}"
          >
            <p>{{savedAt}}</p>
          </lead-update-monitor>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
          <lead-update-business-kit
            :project_id="id"
            :errors="errors"
            @send_businesskit="sendBusinesskit"
            @input="nestedUpdate"
            @bkIdChange="setBusinessKitId"
            :item="item"
            :business_kit_id="businesskit_id"
            :id="lead_id"
          />
        </div>
      </div>
    </div>
    <div
      class="lead-update--tab lead-update--tab-kits"
      :class="{'is-hidden': activeTab != 'stats_tab' }"
    >
      <div class="row gutter-lg">
        <!-- STATISTICS -->
        <div class="col-md-5 col-lg-5 offset-md-1">
          <lead-update-monitor
            @openBusinessCard="triggerPopup"
            :structure="structure"
            :progress="progress"
            :errors="errors"
            :users="users"
            class="inside-content"
            @input="nestedUpdate"
            :item="item"
            :leadReviewEnabled="leadReviewEnabled"
            :class="{'hide': !showUpdateMonitor, 'show': showUpdateMonitor}"
          >
            <p>{{savedAt}}</p>
          </lead-update-monitor>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5">
          <lead-update-statistics :lead-id="lead_id" :project-id="id" />
        </div>
      </div>
    </div>
    <div class="visibility-icon">
      <q-checkbox
        v-model="showUpdateMonitor"
        checked-icon="visibility_off"
        unchecked-icon="visibility_on"
      />
    </div>
    <page-saver
      :sticky="true"
      :isModified="!this.isSaved()"
      :changeCount="saveDiff()"
      @save="submit"
      @cancel="cancel"
    />

    <business-card-popup :item="item" :open="popup_business_card_open"></business-card-popup>
    <lead-create :id="id" />
  </div>
</template>
<script>
import { EventBus } from "@/EventBus.js";
import Api from "@/api/Lead.js";
import LeadApi from "@/api/Lead";
import ProjectApi from "@/api/Project.js";
import UserApi from "@/api/User.js";
import BusinesskitApi from "@/api/BusinessKit";
import Tabs from "@/components/layouts/partials/Tabs";
import LeadMask from "./LeadMask";
import LeadUpdateMonitor from "./LeadUpdateMonitor";
import LeadUpdateBusinessKit from "./LeadUpdateBusinessKit";
import LeadUpdateStatistics from "./LeadUpdateStatistics";
import Field from "@/components/helpers/DataInput/Field";
import CountrySelect from "@/components/helpers/DataInput/CountrySelect";
import Ui from "@/classes/Ui";
import Permission from "@/classes/Permission";
import Mask from "@/classes/Mask";
import GetUrlQueries from "@/classes/GetUrlQueries";
import LeadMaskElement from "@/components/pages/project/leads/LeadMaskElement";
import LeadCreate from "@/components/pages/project/leads/LeadCreate";
import BusinessCardPopup from "@/components/pages/project/leads/BusinessCardPopup";
import PageSaver from "@/components/helpers/Layout/PageSaver";
import { diff as deepObjectDiff } from "deep-object-diff";

// This is an improved version of package "deep-object-diff" to find the differences 
// between to objects which we need to calculate the changes made to a project
const deepCompare = function(obj1, obj2) {
  let occurences = 0;

  const diff = function(obj1, obj2) {
    let key;

    const arraysMatch = function(arr1, arr2) {
      if (arr1.hasOwnProperty('sort') && arr2.hasOwnProperty('sort')) {
        arr1 = arr1.sort();
        arr2 = arr2.sort();
      }

      for (let i = 0; i < arr1.length; i++) {
        let type1 = Object.prototype.toString.call(arr1);
        let type2 = Object.prototype.toString.call(arr2);

        if (type2 === "[object Undefined]") {
          occurences++; 
        } else if (typeof arr1[i] === 'object') {
          occurences += deepCompare(arr1[i], arr2[i])
        } else if (Array.isArray(arr1[i])) {
          arraysMatch(arr1[i], arr2[i])
        } else {
          if (arr2.indexOf(arr1[i]) === -1) {
            occurences++;
          }
        }
      }

      for (let i = 0; i < arr2.length; i++) {
        let type1 = Object.prototype.toString.call(arr1);
        let type2 = Object.prototype.toString.call(arr2);

        if (type2 === "[object Undefined]") {
          occurences++; 
        } else if (typeof arr2[i] === 'object') {
          occurences += deepCompare(arr1[i], arr2[i])
        } else if (Array.isArray(arr2[i])) {
          arraysMatch(arr1[i], arr2[i])
        } else {
          if (arr1.indexOf(arr2[i]) === -1) {
            occurences++;
          }
        }
      }
    };

    const compare = function(item1, item2, key) {
      // Get the object type
      let type1 = Object.prototype.toString.call(item1);
      let type2 = Object.prototype.toString.call(item2);

      // If type2 is undefined it has been removed
      if (type2 === "[object Undefined]") {
        occurences++;

        return;
      }

      // If an object, compare recursively
      if (type1 === "[object Object]") {
        occurences += deepCompare(item1, item2);

        return;
      }

      // If an array, compare
      if (Array.isArray(item1)) {
        arraysMatch(item1, item2);

        return;
      }

      if (item1 !== item2) {
        occurences++;
      }
    };

    // Loop through the first object
    for (key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        compare(obj1[key], obj2[key], key);
      }
    }
  };

  diff(obj1, obj2);

  return occurences;
};

let WEB_APP_ORIGIN = "web_app";

let tabs = [
  { name: "personnal", "is-fullfilled": true },
  { name: "company" },
  { name: "qualify" },
  { name: "kits" }
];

let onLeaving = function(e) {
  var e = e || window.event;
  if (e) {
    e.returnValue = "";
  }
  return "";
};

export default {
  components: {
    Tabs,
    PageSaver,
    LeadUpdateMonitor,
    BusinessCardPopup,
    Field,
    CountrySelect,
    LeadUpdateBusinessKit,
    LeadUpdateStatistics,
    LeadMask,
    LeadCreate
  },
  data() {
    return {
      item: {},
      type: "update",
      errors: [],
      model: "project_leads",
      elements: [],
      level: 3,
      api: new Api(),
      progress: 0,
      next_lead_id: "",
      previous_lead_id: "",
      item_saved: {},
      structure: {},
      language: "",
      users: [],
      fields: [],
      retrieve_method: "show",
      popup_business_card_open: false,
      businesskit_id: null,
      leadReviewEnabled: null,
      showUpdateMonitor: false
    };
  },
  watch: {
    item: {
      handler() {
        this.isSaved();
      },
      deep: true
    }
  },
  props: ["id", "lead_id", "is_existing"],
  computed: {
    activeTab() {
      return this.$store.state.active_tab;
    },
    title() {
      return "ui.pages.lead-edit";
    },
    savedAt() {
      global.moment = moment;
      let date = moment(this.item.updated_at).fromNow();
      let str = "";
      str += this.$t("models.project_lead.message.changes_saved");
      str += " ";
      if (this.isSaved()) {
        str += date;
      } else {
        str += moment(new Date()).fromNow();
      }
      return str;
    },
    singular_model() {
      return this.model.slice(0, -1);
    },
    redirection() {
      return this.model;
    }
  },
  mounted() {
    // retrieve the lead
    this.retrieve(this.lead_id);

    this.init();
    this.item.project_id = this.id;
    if (!this.item.start_date) {
      this.item.start_date = this.item.created_at;
    }

    if (this.is_existing == true) {
      this.$store.commit("SET_NOTIFICATION", {
        title: "models.project_lead.message.leads_exists",
        type: "info"
      });
    }

    EventBus.$on("action", this.handleAction);

    // set project settins
    let project_api = new ProjectApi();
    project_api
      .show(this.id)
      .then(item => {
        Ui.setSubtitle({
          link: { name: "project_show", params: { id: item.id } },
          name: item.name
        });
        this.leadReviewEnabled = item.enable_lead_review;
      })
      .catch(error => {
        Ui.setSubtitle({});
      });

    project_api
      .lead_mask(this.id)
      .then(item => {
        this.structure = item.structure;
        this.language = item.language;
        this.elements = Mask.buildStructure(item.structure);
        this.elements.push({
          name: "kits_tab",
          shouldNotChangeRoute: true,
          title: this.$t("ui.tabs.kits_tab")
        });
        this.elements.push({
          name: "stats_tab",
          shouldNotChangeRoute: true,
          title: this.$t("ui.tabs.stats_tab")
        });
        this.fields = Mask.listFields(item.structure);
        this.fields.push("tags");
        this.$store.commit("SET_TABS", this.elements);
        this.$store.commit("SET_ACTIVE_TAB", this.elements[0].name);
        Ui.setSecondaryHeaderTabs(this.elements);
      })
      .catch(error => {
        console.log(error);
      });
  },
  beforeDestroy() {
    this.$store.commit("EMPTY_TABS");
    this.$store.commit("EMPTY_NOTIFICATION");
    this.$store.commit("SET_SECONDARY_HEADER_TABS", []);
    window.removeEventListener("onbeforeunload", function() {});
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isSaved()) {
      let str = this.$t("ui.global.lead_edit_abort");
      const answer = window.confirm(str);
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    init() {
      this.item = {};
      let permissions = Permission.loadPermissions();
      if (Permission.can(permissions, this.model + "." + this.type)) {
        Ui.setPageLevel(this.level);
        Ui.startLoading();
        this.retrieveAssignedUsers();
      } else {
        this.$store.commit("ADD_ERROR", {
          type: "warning",
          message: "errors.unauthorized"
        });
        this.$router.push({ name: "unauthorized" });
      }
    },
    triggerPopup() {
      this.popup_business_card_open = !this.popup_business_card_open;
    },
    allowPdfDownload() {
      let plan = this.$store.getters.getCurrentOrganizationPlan;
      if (plan && plan.rules["allowed_lead_pdf_download"]) {
        return plan.rules["allowed_lead_pdf_download"];
      }
      return false;
    },
    // We set the BKId with the id and we save the new id in case it does not exist
    setBusinessKitId(id) {
      this.businesskit_id = id;
    },
    retrieveAssignedUsers() {
      let api = new UserApi();
      api
        .all_for_association("email", { project_id: this.id })
        .then(items => {
          this.users = items;
        })
        .catch(error => {
          console.log(error);
        });
    },
    sendBusinesskit(callback) {
      let api = new BusinesskitApi();

      this.save()
        .then(item => {
          api
            .send(this.businesskit_id, this.lead_id)
            .then(item => {
              setTimeout(() => {
                callback("message-success", "models.business_kit.sent");
              }, 500);
            })
            .catch(e => {
              callback("message-error", e.response.data.errors[0].code);
            });
        })
        .catch(e => {
          console.log(e);
        });
    },
    setNotification(res) {
      if (res.found_existing && res.found_existing.length > 0) {
        if (res.found_existing.includes("name")) {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.predicted_name",
            type: "info"
          });
        }
        if (
          res.found_existing.includes("company_contact") ||
          res.found_existing.includes("company")
        ) {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.found_existing",
            type: "info"
          });
        }
      }
    },
    undoChangesDeep(item, difference) {
      Object.keys(item).forEach(key => {
        let value = item[key];
        if (typeof value === "object" && value !== null) {
          item[key] = this.undoChangesDeep(value, difference);
        } else {
          if (key in difference) {
            item[key] = null;
            return item;
          }
        }
      });
    },
    cancel() {
      let difference = deepObjectDiff(this.item, this.item_saved)

      this.undoChangesDeep(this.item, difference);
      this.item = _.cloneDeep(this.item_saved);
    },
    submit() {
      this.save()
        .then(result => {
          this.$store.commit("SET_NOTIFICATION", {
            title: "models.project_lead.message.update",
            type: "success"
          });
        })
        .catch(error => {
          this.$store.commit("SET_NOTIFICATION", {
            title: "errors." + error.response.data.errors[0].code,
            type: "error"
          });
        });
    },
    saveIfNeeded() {
      if (!this.isSaved()) {
        this.save();
      }
    },
    save() {
      let fields = this.fields.map(field => field.name);
      let post_item = Object.keys(this.item)
        .filter(key => fields.includes(key))
        .reduce((obj, key) => {
          obj[key] = this.item[key];
          return obj;
        }, {});

      post_item["project_id"] = this.id;
      post_item["tags"] = this.item.tags;
      post_item["id"] = this.item.id;
      post_item["classification"] = this.item.classification;
      post_item["status"] = this.item.status;
      post_item["user_id"] = this.item.user_id;
      post_item["start_date"] = this.item.start_date;
      post_item["sync_disabled"] = this.item.sync_disabled;
      post_item["opt_in_businesskit"] = this.item.opt_in_businesskit;
      post_item["origin"] = WEB_APP_ORIGIN;
      if (post_item["id"]) {
        return this.postItemPromise(post_item);
      }
    },
    postItemPromise(post_item) {
      return new Promise((resolve, reject) => {
        this.api
          .post(post_item)
          .then(item => {
            this.handleRetrievedLead(item);
            this.errors = [];
            this.$router.push({
              name: "project_lead_edit",
              params: { project_id: this.id, lead_id: item.id }
            });
            resolve(item);
          })
          .catch(e => {
            this.errors = e.response.data.errors;
            this.$store.commit("PREV_TAB");
            reject(e);
          });
      });
    },
    handleAction(action) {
      if (action == "project_leads.download_pdf") {
        let api = new LeadApi();
        api
          .download_pdf(this.item.id)
          .then(item => {
            this.download_message = this.$t(
              "ui.pages.lead-download-pdf-succeed"
            );

            if (item["resource"]["pdf_download_path"]) {
              this.$store.commit("SET_NOTIFICATION", {
                title: "ui.pages.lead-download-pdf-succeed",
                type: "success"
              });
              // trigger pdf in new window
              window.open(item["resource"]["pdf_download_path"], "_blank");
            } else {
              this.$store.commit("SET_NOTIFICATION", {
                title: "ui.pages.lead-download-pdf-error",
                type: "error"
              });
            }
          })
          .catch(error => {});
      }
    },
    // When some item value key/s is/are object/s we need to deep-clone each key/s with their value to be able to track them (vue.js can't deep-watch changes)
    deepCloner(item) {
      let clone = {};
      Object.keys(item).forEach(key => {
        let value = item[key];
        if (Object.prototype.toString.call(value) === "[object Object]") {
          clone[key] = {};
          Object.keys(value).forEach(second_key => {
            let second_value = value[second_key];
            clone[key][second_key] = second_value;
          });
        } else if (Object.prototype.toString.call(value) === "[object Array]") {
          clone[key] = [];
          value.forEach(arr_val => {
            clone[key].push(arr_val);
          });
        } else {
          clone[key] = value;
        }
      });
      return clone;
    },
    isSaved() {
      let diffLength = this.saveDiff();
      if (diffLength < 1) {
        window.removeEventListener("onbeforeunload", onLeaving);
        window.onbeforeunload = null;
        return true;
      } else {
        window.addEventListener("onbeforeunload", onLeaving);
        window.onbeforeunload = onLeaving;
        return false;
      }
    },
    saveDiff() {
      if (!("opt_in_businesskit" in this.item_saved)) {
        this.$set(this.item_saved, "opt_in_businesskit", false);
      }
      if (!("opt_in_businesskit" in this.item)) {
        this.$set(this.item, "opt_in_businesskit", false);
      }
      let diff = this.difference(this.item_saved, this.item);

      return diff;
    },
    // lead retriving
    retrieve(id) {
      this.api[this.retrieve_method](this.lead_id)
        .then(item => {
          this.handleRetrievedLead(item);

          // setting the UI Buttons here so we get access to the next and preivous lead id
          Ui.setHeaderButtons([
            {
              name: "download_pdf",
              action: "project_leads.download_pdf",
              classes: "btn-tertiary",
              icon: "import",
              show: this.allowPdfDownload()
            },
            {
              name: "previous_lead",
              action: "link",
              classes: "btn-tertiary",
              icon: "arrow_left",
              href: this.getPreviousLeadUrl(item.previous_lead_id),
              show: this.showPreviousLeadButton(item.previous_lead_id)
            },
            {
              name: "next_lead",
              action: "link",
              classes: "btn-tertiary",
              icon: "arrow_right",
              href: this.getNextLeadUrl(item.next_lead_id),
              show: this.showNextLeadButton(item.next_lead_id)
            },
            {
              name: "project_lead",
              action: "project_leads.add_popup",
              classes: "btn-primary",
              icon: ""
            }
          ]);

          Ui.setTitleName(this.item);
          Ui.finishLoading();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    handleRetrievedLead(item) {
      // Insert custom Lead Mask attributes into Lead and insert into datastore
      item = this.insertCustomLeadMaskAttributes(item);
      item = this.sanitizeValues(item);
      this.item = item;
      this.item_saved = JSON.parse(JSON.stringify(item));

      // retrieve and remember next and previous lead_id
      this.next_lead_id = this.item.next_lead_id;
      this.previous_lead_id = this.item.previous_lead_id;

      // Check wrong email domain
      if (typeof this.item.has_valid_email != "undefined") {
        this.setWrongEmailDomain();
      }
      this.setNotification(item);
      this.setLeadMaskProgress();
    },
    sanitizeValues(item) {
      // We had empty string values from backend, we want to convert these values to null, otherwise  when we just access a lead it can show unsaved changes without editing.
      Object.keys(item).forEach(key => {
        let value = item[key];
        if (value === undefined || value === "") {
          item[key] = null;
        }
      });
      return item;
    },
    setLeadMaskProgress() {
      // Calculate attribute progress for Lead Mask
      this.progress = parseFloat(this.item.progress_indicator_lead_mask) * 100;
    },
    // Will initialisate data
    // with default values and all
    insertCustomLeadMaskAttributes(item) {
      // init an empty array for checkbox
      for (var key in this.structure) {
        let field = this.structure[key];

        if (item[key] == undefined && field.element_type.includes("checkbox")) {
          item[key] = new Array();
        } else if (field.element_type.includes("quantity_selection")) {
          if (item[key] == undefined) {
            item[key] = new Object();
          }
          field.allowed_values.forEach(allowed_value => {
            if (!item[key][allowed_value.value]) {
              // When there is no value we initialize it with "0" instead 'null'. Then we can track changes well (including 0 when there is no value).
              // * All values in quantity selection type, are defined as '0' to 'x' numbers.
              item[key][allowed_value.value] = "0";
            }
          });
        }
        if (field["default_value"] && !item[key]) {
          item[key] = field["default_value"];
        }
        if (field.standard_field !== undefined && !(field.name in item)) {
          item[field.name] = null;
        }
        // When for other reasons, the key is not defined in the item, then we still can initialize it.
        if (item[key] == undefined) {
          item[field.name] = null;
        }
      }
      return item;
    },
    setWrongEmailDomain() {
      if (!this.item.has_valid_email) {
        this.errors.push({
          code: "lead.email.invalid_domain",
          field_name: "email"
        });
      }
    },
    //  We emit the change in (object, label, name) to include and track changes form botton to top (QuantitySelection < LeadMaskElement < LeadMask < LeadUpdate)
    change(object, label, name) {
      let value = this.item[label];
      this.$set(this.item, label, {});
      value[name] = object[name];
      this.item[label] = value;

      this.$forceUpdate();
    },
    populateFields(companyFields) {
      let deepFields = JSON.parse(JSON.stringify(companyFields));
      this.item = Object.assign(this.item, deepFields);
      this.saveDiff();
    },
    nestedUpdate(name, value) {
      if (!(name in this.item_saved)) {
        this.$set(this.item_saved, name, undefined);
      }
      this.item[name] = value;
    },
    flattenObject(ob) {
      let flattenedOb = Object.assign(
        {},
        ...(function _flatten(o) {
          return [].concat(
            ...Object.keys(o).map(k =>
              typeof o[k] === "object" && o[k] !== null
                ? _flatten(o[k])
                : { [k]: o[k] }
            )
          );
        })(ob)
      );
      return flattenedOb;
    },
    // Deep comparaison between objects
    difference(object, base) {
      var o = deepCompare(_.cloneDeep(base), _.cloneDeep(object));

      return o;
    },
    getPreviousLeadUrl(previous_lead_id) {
      let url_queries = GetUrlQueries.urlQueries(this.$route.query);
      return `/${this.$t("routes.project")}/${this.item.project_id}/${this.$t(
        "routes.project_leads"
      )}/${previous_lead_id}/edit${url_queries}`;
    },
    getNextLeadUrl(next_lead_id) {
      let url_queries = GetUrlQueries.urlQueries(this.$route.query);
      return `/${this.$t("routes.project")}/${this.item.project_id}/${this.$t(
        "routes.project_leads"
      )}/${next_lead_id}/edit${url_queries}`;
    },
    showPreviousLeadButton(previous_lead_id) {
      if (previous_lead_id) {
        return true;
      }
      return false;
    },
    showNextLeadButton(next_lead_id) {
      if (next_lead_id) {
        return true;
      }
      return false;
    }
  }
};
</script>
<style lang="scss">
.lead-mask {
  margin-bottom: 10px;
  .input--datepicker {
    width: 100% !important;
    margin: 5px 0 0 !important;
    margin-bottom: 10px !important;
  }
}

.visibility-icon {
  z-index: 101;
  position: absolute;
  right: 8px;
  top: 240px;
  color: #fff;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  background-color: rgba(27, 136, 253, 0.4);
  border-radius: 50%;
  overflow: hidden;
  .material-icons {
    justify-content: inherit;
    color: #fff;
  }
  .q-checkbox-checked {
    color: #fff !important;
  }
  i {
    line-height: 20px;
    margin-right: 2px;
  }
}

.field.is-buttonned {
  .field--wrapper {
    .field--checkbox {
      label {
        margin-bottom: 0px !important;
        margin-top: 0px !important;
      }
      label:hover {
        border: 2px solid $paper;
      }
    }
  }
}

/* forcing this to overwrite all the shitty label styles we have */
label.text-label {
  font-size: 15px !important;
  font-weight: 500 !important;
  line-height: 24px !important;
  color: #454a5b !important;
  padding-bottom: 6px !important;
  text-align: left !important;
}

.secondary-header--title .organization {
  font-size: 14px;
  display: block;
}
.lead-update {
  h3 {
    font-weight: 200;
    font-size: 2.1em;
    margin-bottom: 0.8em;
  }
}
.field.is-optional label .optional {
  display: none;
}
.lead-update--tab {
  .gutter-lg > div {
    @media (max-width: 576px) {
      padding-top: 20px !important;
    }
  }
}
.lead-update--tab.is-hidden {
  display: none;
}
.main-content.main-content--lead {
  padding: 0;
  box-shadow: none;
  background: transparent;
}

.bottom-zone .field {
  margin-bottom: 20px;
  margin-top: 0;
}

.lead-update-content {
  border-radius: 3px;
  @include respond-to("small-up") {
    margin: 0;
  }
}

.next-button {
  margin-top: 2em;
  text-align: center;
}

.lead-update-monitor.outside-content {
  @include respond-to("large-up") {
    display: none;
  }
}

.lead-update-monitor label[for="user_id"] + .input--select-wrapper::after {
  background-color: #f2f2f2;
}

@include respond-to("large-up") {
  .lead-update--tab > .top-zone {
    margin-top: -1em;
    margin-bottom: 2em;
  }
}

.inside-content {
  background: darken($color-white, 5);
  left: -0.5em;
  padding-top: 1em;
  position: relative;
  @include respond-to("large-up") {
    display: flex;
  }
  .lead-update-monitor--business-card,
  .lead-update-monitor--advancement,
  .lead-update-monitor--more {
    width: auto;
    display: block;
  }
}

// disable tickling
.tabs .tab .icon {
  display: none;
}

.lead-update-content .bottom-zone {
  .field-radio > label,
  .field-checkbox > label {
    font-size: 1.5em;
    margin-bottom: 1.3em;
    color: $ink-dark;
  }
}

.saving-message {
  font-style: italic;
  color: lighten($color-black, 45);
}

.fake-content {
  margin-top: 3em;
}

.form-part {
  background-color: #fff;
  position: relative;

  .container {
    padding-left: 0;
    max-width: 100%;
  }
}

@media (max-width: 765px) {
  .lead-mask {
    padding: 0 20px;
  }
}
@media (max-width: 575px) {
  .lead-update--tab {
    .row {
      justify-content: center;
    }
  }
  .hide {
    opacity: 0;
    max-height: 0 !important;
    transition: 0.15s all ease-in-out;
  }
  .show {
    opacity: 1;
    transition: 0.15s all ease-in-out;
  }
}
@media (min-width: 576px) {
  .visibility-icon {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// LeadUpdate.vue?630b5e4f